/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./refund.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./refund.component";
var styles_RefundComponent = [i0.styles];
var RenderType_RefundComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_RefundComponent, data: {} });
export { RenderType_RefundComponent as RenderType_RefundComponent };
export function View_RefundComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["\n  refund works!\n"])), (_l()(), i1.ɵted(-1, null, ["\n"]))], null, null); }
export function View_RefundComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-refund", [], null, null, null, View_RefundComponent_0, RenderType_RefundComponent)), i1.ɵdid(1, 114688, null, 0, i2.RefundComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var RefundComponentNgFactory = i1.ɵccf("app-refund", i2.RefundComponent, View_RefundComponent_Host_0, {}, {}, []);
export { RefundComponentNgFactory as RefundComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/refund/refund.component.ngfactory.js.pre-build-optimizer.js